export function setMemberNameFilter(memberName: string)
{
  return {
    type: ActionType.ApplyMemberNameFilter,
    value: memberName
  }
}

export function setBusinessNameFilter(businessName: string)
{
  return {
    type: ActionType.ApplyBusinessNameFilter,
    value: businessName
  }
}

export function setCategoryFilter(category: string)
{
  return {
    type: ActionType.ApplyCategoryFilter,
    value: category
  }
}

export function resetFilters()
{
  return {
    type: ActionType.ResetFilters
  }
}

export function initializeMembers(members: Array<any>)
{
  return {
    type: ActionType.LoadMembers,
    value: members
  }
}

export function goToPage(page: number)
{
  return {
    type: ActionType.GoToPage,
    value: page
  }
}


export function prevPage()
{
  return {
    type: ActionType.PrevPage
  }
}

export function nextPage()
{
  return {
    type: ActionType.NextPage
  }
}




export class ActionType
{
  static get ApplyMemberNameFilter()
  {
    return "ApplyMemberNameFilter";
  }

  static get ApplyBusinessNameFilter()
  {
    return "ApplyBusinessNameFilter";
  }

  static get ApplyCategoryFilter()
  {
    return "ApplyCategoryFitler";
  }

  static get ResetFilters()
  {
    return "ResetFilters";
  }

  static get MembersUpdated()
  {
    return "MembersUpdated";
  }

  static get BrowserNavigated()
  {
    return "BrowserNavigated";
  }

  static get LoadMembers()
  {
    return "LoadMembers";
  }

  static get GoToPage()
  {
    return "GoToPage";
  }

  static get PrevPage()
  {
    return "PrevPage";
  }

  static get NextPage()
  {
    return "NextPage";
  }

}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/actions.ts